import React, { useState, useEffect } from "react";
import "./AdContainer.scss";
import { useTranslation } from "react-i18next";
import sizeMe from "react-sizeme";

function AdContainer({ location, size }) {
  const [fetching, setFetching] = useState(false);
  const [ads, setAds] = useState(null);
  const [lastLocation, setLastLocation] = useState(null);

  const { t } = useTranslation();

  useEffect(() => {
    //console.log("ad sensor effect", location);
    // once per address (v2-1438): with "ads === null ||", a failed ads.php was asked again at once, without end
    if (!fetching && location.pathname !== lastLocation) {
      let url =
        window.serverUrl+"/social/ads/ads.php?&t=" + Math.random();
      setFetching((f) => true);
      setLastLocation((l) => location.pathname);
      fetch(url)
        .then((r) => r.json())
        .then((_data) => {
          // ads first: React 17 renders each setState of a promise callback on its own, and a render
          // with fetching=false and ads=null made the effect fetch ads.php a second time
          setAds((u) => _data);
          setFetching((f) => false);
        })
        .catch((err) => {
          setFetching((f) => false);
          console.error("fetch problem", err);
        });
    }
    return () => {};
  }, [fetching, size.width, ads, lastLocation, location]);

  return (
    <>
      {ads !== null ? (
        <div className="ad-container">
          <div className="title">{t("ads.sponsored")}</div>
          {!fetching && ads !== null && size.width > 0 ? (
            <>
              <a
                href={ads.small.link}
                className="small"
                alt=""
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={ads.small.url} alt="" />
              </a>
              <a
                href={ads.large.link}
                className="large"
                alt=""
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={ads.large.url} alt="" />
              </a>
            </>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
export default sizeMe({
  monitorWidth: true
})(AdContainer);
